<template>
  <div>
    <b-button-group class="float-sm-left" size="sm">
      <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/fitburstMCMC.vue" target="_blank" style="color:black">
        <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
      </a>
    </b-button-group>
    <b-button variant="dark" size="sm" @click="unsaveParameters('intensity-mcmc')">UnSave Results</b-button>
    <b-button variant="success" size="sm" @click="saveParameters('intensity-mcmc')">Save Results</b-button>
    <b-button variant="danger" size="sm" @click="flagParameters('intensity-mcmc')">Flag for Pipeline Expert</b-button>
    <b-button class="float-sm-right" variant="warning" size="sm" @click="badParameters('intensity-mcmc')">Bad Data</b-button>
    <div v-for="(round, index) in fitburstMCMCItems" :key="index" style="margin-top: 50px">
      <b-row>
        <b-col md="4">
          <h3>Fit</h3>
          <b-img-lazy fluid v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['plot']}`"/>
        </b-col>
        <b-col md="4">
          <h3>Corner Plot</h3>
          <b-img-lazy fluid v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['corner']}`"/>
        </b-col>
        <b-col md="4" style="margin-top: 90px">
            <b-row style="margin-bottom: 15px">
              <b>Fitburst MCMC Parameters:</b>
            </b-row>
            <table border="0">
              <tr align="left">
                <td> DM: </td>
                <td> {{ round['fitData']['dm'] }} +/- {{ round['fitData']['dm_error'] }} </td>
              </tr>
              <tr align="left">
                <td>  Pulse Width (s): </td>
                <td> {{ round['fitData']['width'] }} </td>
              </tr>
              <tr align="left">
                <td>  Fluence: </td>
                <td> {{ round['fitData']['fluence'] }} +/- {{ round['fitData']['fluence_error'] }}</td>
              </tr>
              <tr align="left">
                <td>  Scattering Time (s): </td>
                <td> {{ round['fitData']['scattering_timescale'] }} +/- {{ round['fitData']['scattering_timesccale_error'] }}</td>
              </tr>
              <tr align="left">
                <td>  Spectral Index: </td>
                <td> {{ round['fitData']['spectral_index'] }} +/- {{ round['fitData']['spectral_index_error'] }}</td>
              </tr>
              <tr align="left">
                <td>  Spectral Running: </td>
                <td> {{ round['fitData']['spectral_running'] }} +/- {{ round['fitData']['spectral_running_error'] }}</td>
              </tr>
              <tr align="left">
                <td>  Width(s): </td>
                <td> {{ round['fitData']['width'] }} +/- {{ round['fitData']['width_error'] }}</td>
              </tr>
            </table>
          </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default{
  props: [
    'unsaveParameters',
    'saveParameters',
    'flagParameters',
    'badParameters',
    'fitburstMCMCItems'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/fitburstMCMC.vue